const es = {
  meta: {
    title: "AGUSTÍN GARCÍA",
    description: "Soy Agustín García, desarrollador Frontend",
  },
  nav: {
    home: "Inicio",
    portfolio: "Portfolio",
    about: "Sobre mí",
    contact: "Contacto",
    linkedin: "LinkedIn",
    github: "Github",
    copyright: "© {{year}} {{name}}",
  },
  home: {
    title: "Soy Agustín García",
    available: "Disponible para proyectos",
    animated: {
      first: "Me encanta programar",
      second: "Creo webs modernas",
      third: "Desarrollo apps con React",
    },
    description:
      "FullStack Developer freelance desde 2020. Wordpress, PrestaShop, Shopify y apps iOS/Android.",
    portfolioBtn: "Mi Portfolio",
    contactBtn: "Contáctame",
    scroll: "Scroll",
    highlightsTitle: "Lo que hago",
    highlightsSubtitle:
      "Productos digitales para clientes reales: web, plugins, ecommerce y apps.",
    highlights: {
      wordpress: {
        title: "Wordpress & plugins",
        text: "Webs Elementor, SEO, reservas y plugins a medida para clientes de AG Marketing.",
      },
      react: {
        title: "React & Frontend",
        text: "Interfaces modernas, bloques Gutenberg y motion fluido listo para producto.",
      },
      apps: {
        title: "Apps React Native",
        text: "PartFri y Guardify: Expo, APIs, Firebase, Laravel y capas de IA.",
      },
    },
    stats: {
      projects: "Proyectos entregados",
      years: "Años freelance",
      clients: "Clientes reales",
      offer: "Web, ecommerce y apps",
      offerValue: "A medida",
    },
    marqueeTitle: "Stack & herramientas",
    featuredTitle: "Trabajos destacados",
    featuredSubtitle: "Productos AG Marketing y proyectos con impacto real.",
    processTitle: "Cómo trabajo",
    processSubtitle: "Proceso claro, comunicación constante y entrega con calidad.",
    process: {
      discover: {
        title: "Descubrir",
        text: "Entiendo el negocio, el usuario y los objetivos del producto.",
      },
      design: {
        title: "Diseñar",
        text: "Definimos UX, estructura y dirección visual antes de construir.",
      },
      build: {
        title: "Construir",
        text: "Código limpio, componentes reutilizables y rendimiento sólido.",
      },
      launch: {
        title: "Lanzar",
        text: "Deploy, QA, ajustes finales y soporte post-lanzamiento.",
      },
    },
    seeWork: "Ver trabajos",
    aboutCta: "Conóceme",
    ctaBandTitle: "¿Listo para construir algo memorable?",
    ctaBandText: "Cuéntame tu idea y la convertimos en producto digital.",
    folioLabel: "Folio / 2020 — Actualidad",
    heroLine1: "FULL",
    heroLine2: "STACK",
    heroLine3: "DEVELOPER",
    featuredCount: "Proyectos destacados ({{count}})",
    visitSite: "Visitar sitio",
    talkMarquee:
      "HABLEMOS — COLABOREMOS — DI HOLA — ¿EMPEZAMOS ALGO? — ",
    splitEyebrow: "desde 2020",
    splitLeft: "FullStack",
    splitRight: "Developer",
    splitText:
      "Construyo webs, ecommerce y apps: Wordpress, Shopify, PrestaShop y React Native. Código limpio, UX clara y productos que funcionan en el día a día.",
    storyEyebrow: "Cómo trabajo",
    storyTitle: "Web, ecommerce y apps en producción",
    story: {
      craft: {
        tag: "Web / Wordpress",
        heading: "Sitios a medida que cargan y convierten",
        text: "Landing, corporativas y plugins para AG Marketing: Elementor, SEO, reservas y código limpio listo para cliente real.",
      },
      product: {
        tag: "Ecommerce",
        heading: "Tiendas que venden sin fricción",
        text: "Shopify, PrestaShop y Wordpress Woo: catálogo, checkout y rendimiento pensados para leads y ventas.",
      },
      apps: {
        tag: "Apps móviles",
        heading: "React Native en el día a día",
        text: "PartFri y Guardify: flujos reales, APIs, Firebase, Laravel y capas de IA ya en producción.",
      },
    },
    casesEyebrow: "Casos seleccionados",
    casesTitle: "Proyectos con impacto",
    seeCase: "Ver caso",
    scrollHint: "Scroll para explorar",
    dragHint: "Scroll para mover lateral",
    interestsTitle: "Stack & herramientas",
    interestsSubtitle: "Con lo que construyo productos cada semana.",
    valuesTitle: "Qué me diferencia",
    valuesSubtitle: "Detalle, velocidad y colaboración real con el cliente.",
    values: {
      speed: {
        title: "Velocidad con criterio",
        text: "Entrego rápido sin sacrificar calidad ni accesibilidad.",
      },
      craft: {
        title: "Producto usable",
        text: "Flujos claros, rendimiento y detalle en cada entrega.",
      },
      collab: {
        title: "Colaboración clara",
        text: "Comunicación directa, demos frecuentes y feedback útil.",
      },
    },
    testimonialsTitle: "Reseñas",
    testimonialsSubtitle: "Lo que dicen clientes y equipos con los que trabajo.",
    testimonials: {
      one: {
        quote:
          "Agustín entiende el negocio y traduce ideas en interfaces claras y rápidas.",
        author: "Cliente producto digital",
        role: "Product Owner",
      },
      two: {
        quote:
          "Entrega limpia, buena comunicación y atención al detalle en cada sprint.",
        author: "Equipo marketing",
        role: "Project Lead",
      },
      three: {
        quote:
          "Montó la web y el plugin de reservas sin fricción. Cliente contento y plazos cumplidos.",
        author: "Lechuzas Properties",
        role: "Cliente inmobiliario",
      },
      four: {
        quote:
          "En PartFri y Guardify resolvió flujos complejos con APIs y React Native de forma sólida.",
        author: "AG Marketing",
        role: "Producto / Apps",
      },
      five: {
        quote:
          "Shopify y Wordpress a medida, comunicación directa y resultados medibles en ventas.",
        author: "Ecommerce retail",
        role: "Founder",
      },
    },
  },
  about: {
    pageTitle: "Sobre mí",
    aboutTitle: "Quién soy",
    heroEyebrow: "FullStack · Freelance · 2020+",
    heroTitle: "Código, producto y clientes reales",
    aboutme:
      "Frontend Developer apasionado por aprender, afrontar retos y crear productos que mejoren la vida de las personas. Trabajo entre webs Wordpress a medida, ecommerce y apps React Native (AG Marketing), con foco en rendimiento, UX y detalle visual. Me gusta estar al día con nuevas tecnologías. Fun fact: me encanta tocar la guitarra y jugar al fútbol.",
    timeline: "Experiencia laboral",
    education: "Formación",
    languages: "Idiomas",
    skills: "Habilidades",
    services: "Servicios",
    download: "CV",
    nowTitle: "Ahora mismo",
    nowText:
      "FullStack Developer freelance desde 2020 (Wordpress, PrestaShop, Shopify y apps). Proyectos también con AG Marketing (Guardify / PartFri).",
    focusLabel: "Foco",
    focusWeb: "Web & plugins",
    focusShop: "Ecommerce",
    focusApps: "Apps React Native",
    work: {
      freelance: {
        company: "Freelance",
        role: "FullStack Developer",
        date: "2020 — Actualidad",
      },
      doowebs: {
        company: "Doowebs",
        role: "FullStack Developer",
        date: "Sep 2024",
      },
      anartxy: {
        company: "Anartxy",
        role: "Software Developer",
        date: "Ene 2023 — Ago 2023",
      },
      assembler: {
        company: "Assembler Institute of Technology",
        role: "Frontend Developer",
        date: "Feb 2022 — Nov 2022",
      },
      radoo: {
        company: "Radoo",
        role: "Project & Marketing Manager",
        date: "2020 — 2021",
      },
    },
    educationItems: {
      assembler: "Máster en Software Development (1200h+, MERN & LAMP, Agile)",
      florida: "Grado en Leadership, Entrepreneurship and Innovation",
      ceu: "ADE + Marketing (2 años)",
    },
    langLevels: {
      native: "Nativo",
      professional: "Profesional",
      technical: "Técnico",
    },
    langNames: {
      es: "Español",
      ca: "Catalán",
      en: "Inglés",
      ko: "Coreano",
    },
  },
  portfolio: {
    pageTitle: "Portfolio",
    subtitle:
      "Proyectos reales de AG Marketing, freelance y productos propios: webs, plugins, ecommerce y apps.",
    viewProject: "Ver proyecto",
    open: "Abrir",
    filterAll: "Todos",
    filterWeb: "Web",
    filterCode: "Código",
    filterShop: "Ecommerce",
    filterApp: "Apps",
    count: "{{count}} proyectos",
    blurbs: {
      partfri:
        "App iOS/Android para organizar fiestas: invitados, compras colaborativas, Spotify y juegos.",
      guardify:
        "App sanitaria de turnos con React Native, Laravel, Firebase y capa IA (GuardifIA).",
      lechuzas:
        "Web inmobiliaria/vacacional con Elementor, multidioma y reservas personalizadas.",
      selectyourvet:
        "Plataforma veterinaria con plugin custom, buscador avanzado e IA.",
      agmarketing:
        "Web de AG Marketing: diseño, SEO, plugins a medida y captación de clientes.",
      afterbite: "Web corporativa enfocada en conversión y claridad de producto.",
      calculator: "UI interactiva con lógica JS limpia y feedback inmediato.",
      melody: "Plataforma musical full stack con auth, playlists y API.",
      gif4u: "App React + Firebase para buscar y guardar GIFs.",
      pilatu: "Sitio fitness con foco en marca y captación de leads.",
      dermobal: "Presencia digital dermatológica limpia y profesional.",
      prolink: "Web de servicios con arquitectura Wordpress a medida.",
      anartxy: "Ecommerce con Shopify, catálogo y experiencia de marca.",
      spotify: "Clone front de Spotify con UI moderna y responsive.",
      fenix: "Sitio de eventos/escenario con identidad visual fuerte.",
      radoo:
        "Web para hostelería (cartas digitales → delivery) durante COVID.",
      waqua: "Web Wordpress + Elementor con integraciones y UX moderna.",
      triptomax: "Landing/web de viajes con CTA y SEO básico.",
      dentalcorbella:
        "Clínica dental: diseño web, marketing y animaciones (AG Marketing).",
      valy: "Ecommerce beauty con catálogo y experiencia de marca.",
      v3nture:
        "Plataforma V3B / V3nture Builders: plugin custom y buscador de servicios web3.",
      boconni: "Real estate premium con galería y posicionamiento.",
      lowgas:
        "App React Native de gasolineras baratas: precios Ministerio, rutas Google, navegación y CarPlay (AG Marketing).",
      tapiter:
        "Web corporativa Vite para fabricante de tejidos (tapicería, contract y moda): marca, UX y frontend moderno.",
    },
    items: {
      partfri: "PartFri (App iOS/Android · AG Marketing)",
      guardify: "Guardify (React Native · Laravel · IA)",
      lowgas: "LowGas (React Native · Maps · AG Marketing)",
      tapiter: "Tapiter (Vite · Frontend)",
      lechuzas: "Lechuzas Properties (Wordpress · Bookings)",
      selectyourvet: "Select Your Vet (Plugin + IA)",
      agmarketing: "AG Marketing (Web corporativa)",
      afterbite: "AfterBite (Wordpress)",
      calculator: "Calculadora con Javascript",
      melody: "Melody Music Stream (React, NodeJS, MongoDB)",
      gif4u: "Gif 4 U (React, Firebase)",
      pilatu: "PilatuFitness (Wordpress)",
      dermobal: "Dermobal (Wordpress)",
      prolink: "Prolink (Wordpress)",
      anartxy: "Anartxy (Shopify)",
      spotify: "Spotify Clone Front (React)",
      fenix: "Fenix (Wordpress)",
      radoo: "Radoo (Wordpress · Hostelería)",
      waqua: "Waqua (Wordpress)",
      triptomax: "Triptomax (Wordpress)",
      dentalcorbella: "Dental Corbella (Wordpress · AG Marketing)",
      valy: "Valy Cosmetics (Wordpress)",
      v3nture: "V3B / V3nture Builders (Plugin custom)",
      boconni: "Boconni (Wordpress)",
    },
  },
  services: {
    agmarketing: {
      title: "Webs & plugins (AG Marketing)",
      description:
        "Desarrollo Wordpress/Elementor y productos custom para clientes reales: SEO, plugins, mapas y front moderno (Select Your Vet, Lechuzas, LowGas, Tapiter…).",
    },
    apps: {
      title: "Apps iOS & Android",
      description:
        "Productos móviles con React Native + Expo: PartFri, Guardify y LowGas (mapas, rutas y CarPlay).",
    },
    programming: {
      title: "Full stack & ecommerce",
      description:
        "Más de 1200h en Assembler (MERN/LAMP, Agile). Ecommerce con PrestaShop/Shopify y proyectos freelance con PHP, JS, Gutenberg y temas/plugins propios.",
    },
  },
  contact: {
    pageTitle: "Contacto",
    getInTouch: "Hablemos",
    eyebrow: "Disponible para proyectos",
    heroTitle: "Cuéntame qué quieres construir",
    email: "Email",
    phone: "Teléfono",
    description:
      "¿Tienes un proyecto en mente? Escríbeme y hablamos sobre cómo puedo ayudarte.",
    namePlaceholder: "Nombre",
    emailPlaceholder: "Email",
    messagePlaceholder: "Cuéntame el proyecto, plazos y presupuesto aproximado",
    sending: "Enviando...",
    send: "Enviar mensaje",
    success: "¡Mensaje enviado! Gracias por contactarme.",
    error: "Error al enviar. Inténtalo de nuevo.",
    response: "Respuesta habitual en 24–48h",
  },
  lang: {
    es: "ES",
    en: "EN",
    label: "Idioma",
  },
};

export default es;
